module.exports = __webpack_public_path__ + "static/media/argentina.4b12b90a.svg";